import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import CustomCurrencyInput from "components/CustomCurrencyInput/CustomCurrencyInput.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import { useLocation, useHistory } from 'react-router-dom';
import * as constants from "../../constantsuniodonto";
import Snackbar from "@material-ui/core/Snackbar/Snackbar";
import MuiAlert from "@material-ui/lab/Alert/Alert";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const dependentService = require('../../services/DependentService');

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
};

const useStyles = makeStyles(styles);

export default function DependentsPage() {
  
  const {search} = useLocation();
  
  const [isEdit, setIsEdit] = React.useState(false);
  const [typeList, setTypeList] = React.useState(constants.userTypeList);
  const [sexList, setSexList] = React.useState(constants.sexList);
  const [dependentTypeList, setDependentTypeList] = React.useState(constants.dependentTypeList);
  const [openSuccess, setOpenSuccess] = React.useState(false);
  const [openError, setOpenError] = React.useState(false);
  const [requestMessage, setRequestMessage] = React.useState('');
  const [entityID, setEntityID] = React.useState(null);
  const [openRemoveConfirmation, setOpenRemoveConfirmation] = React.useState(false);
  const [dependent, setDependent] = React.useState({
    name: '',
    born: '',
    social_number: '',
    parentName: '',
    sex: '',
    type: ''
  });
  
  const classes = useStyles();
  
  React.useEffect(() => {
    let id;
    if(search.indexOf('id=') !== -1){
      id = search.replace('?id=', '');
      setEntityID(id);
      dependentService.get(id).then((response) => {
        setDependent(response.data);
        setIsEdit(true);
      });
    }
  },[]);
  
  let history = useHistory();
  
  function handleSaveButton(){
    if(isEdit){
      dependentService.update(dependent).then((response) => {
        setRequestMessage('Dependente Atualizado com Sucesso');
        setOpenSuccess(true);
      });
    }else{
      dependentService.create(dependent).then((response) => {
        setDependent(response.data);
        history.push(`${constants.SITE_URL}/admin/create-dependent?id=${response.data._id}`);
        setEntityID(response.data._id);
        setIsEdit(true);
        setOpenSuccess(true);
        setRequestMessage('Dependente Criado com Sucesso');
      });
    }
  }
  
  function handleDeleteButton(){
    dependentService.remove(entityID).then((response) => {
      history.push(`${constants.SITE_URL}/admin/dependents`);
      setOpenSuccess(true);
      setRequestMessage('Dependente Removido com Sucesso');
      handleCloseRemoveConfirmation();
    }, () => {
      setRequestMessage(`Problema ao remover o Dependente`);
      setOpenError(true);
      handleCloseRemoveConfirmation();
    });
  }
  
  const closeAlert = (event, reason) => {
    setOpenSuccess(false);
    setOpenError(false);
  };
  
  const handleClickOpenRemoveConfirmation = () => {
    setOpenRemoveConfirmation(true);
  };
  
  const handleCloseRemoveConfirmation = () => {
    setOpenRemoveConfirmation(false);
  };
  
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Criar Dependente</h4>
              <p className={classes.cardCategoryWhite}>Dependente será comercializado pela plataforma</p>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Nome"
                    id="name"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      value: dependent.name,
                      onChange: (event) => {
                        setDependent({
                          ...dependent,
                          name: event.target.value
                        });
                      }
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Nascimento"
                    id="born"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      value: dependent.born,
                      type: 'text',
                      onChange: (event) => {
                        setDependent({
                          ...dependent,
                          born: event.target.value
                        });
                      }
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="CPF"
                    id="social_number"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      value: dependent.social_number,
                      type: 'number',
                      onChange: (event) => {
                        setDependent({
                          ...dependent,
                          social_number: event.target.value
                        });
                      }
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Nome da Mãe"
                    id="parentName"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      value: dependent.parentName,
                      onChange: (event) => {
                        setDependent({
                          ...dependent,
                          parentName: event.target.value
                        });
                      }
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomSelect
                    labelText="Sexo"
                    id="sex"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      value: dependent.sex,
                      options: sexList,
                      onChange: (event) => {
                        setDependent({
                          ...dependent,
                          sex: event.target.value
                        });
                      }
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter>
              <Button color="primary" onClick={handleSaveButton}>Salvar Dependente</Button>
              {isEdit && (
                <Button color="danger" onClick={handleClickOpenRemoveConfirmation}>Excluir Dependente</Button>
              )}
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <Snackbar open={openSuccess} autoHideDuration={2000} onClose={closeAlert}>
        <Alert severity="success">
          {requestMessage}
        </Alert>
      </Snackbar>
      <Snackbar open={openError} autoHideDuration={2000} onClose={closeAlert}>
        <Alert severity="error">
          {requestMessage}
        </Alert>
      </Snackbar>
      <Dialog
        open={openRemoveConfirmation}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseRemoveConfirmation}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{"Alerta"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Tem certeza que quer remover esse registro?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseRemoveConfirmation} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleDeleteButton} color="danger">
            Remover
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
